import HorizontalTile from "../../components/universal/HorizontalTile";
import avatar from "../../assets/icons/squareCard/story1.png";
import avatar2 from "../../assets/icons/StoryCircles/story1.png";

export const tabsTitleArray = ["Users", "Testimonies", "Givings"];
export const tabsContentObject = {
  Users: (
    <>
      <HorizontalTile
        avatarImage={avatar}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
      <HorizontalTile
        avatarImage={avatar}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
      <HorizontalTile
        avatarImage={avatar}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
      <HorizontalTile
        avatarImage={avatar}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
    </>
  ),
  Testimonies: (
    <>
      <HorizontalTile
        avatarImage={avatar2}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
      <HorizontalTile
        avatarImage={avatar2}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
      <HorizontalTile
        avatarImage={avatar2}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
      <HorizontalTile
        avatarImage={avatar2}
        headingText={"Simon Greeves"}
        headingColor={"#979592"}
        headingFontSize={"13px"}
        subHeadingText={"@simon89"}
        subHeadingColor={"#808191"}
        subHeadingFontSize={"12px"}
        date={"26 mo"}
        dateColor={"#979592"}
      />
    </>
  ),
};
export const curriculumHeaders = [
  {
    headerName: "Curriculum Name",
    headerId: "curriculumName",
  },
  {
    headerName: "Description",
    headerId: "description",
  },
  {
    headerName: "Views",
    headerId: "views",
  },
  {
    headerName: "% of com",
    headerId: "percent",
  },
];
export const curriculumData = [
  {
    curriculumName: "The Book of John",
    description: "We become what we think ab...",
    views: "128",
    percent: "24%",
  },
  {
    curriculumName: "Acts of Apostles",
    description: "We become what we think ab...",
    views: "128",
    percent: "24%",
  },
  {
    curriculumName: "Book of Matthew",
    description: "We become what we think ab...",
    views: "128",
    percent: "24%",
  },
  {
    curriculumName: "Parables",
    description: "We become what we think ab...",
    views: "128",
    percent: "24%",
  },
  {
    curriculumName: "Book of Luke",
    description: "We become what we think ab...",
    views: "128",
    percent: "24%",
  },
];
export const allCurriculumHeaders = [
  {
    headerName: "Curriculum Name",
    headerId: "curriculum_name",
  },
  {
    headerName: "Description",
    headerId: "curriculum_description",
  },
  {
    headerName: "Last Modified Date",
    headerId: "lastUpdatedDate",
    date: true,
  },
  {
    headerName: "Views",
    headerId: "views",
  },
  {
    headerName: "Is Published",
    headerId: "publish",
  },
  {
    headerName: "Actions",
    headerId: "actions",
  },
];
export const allCurriculumData = [
  {
    title: "Book of John",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est, tenetur.",
    date: "12/03/2023",
    views: "122",
  },
  {
    title: "Parabies",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est, tenetur.",
    date: "12/03/2023",
    views: "122",
  },
  {
    title: "Jesus Speaks",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est, tenetur.",
    date: "12/03/2023",
    views: "122",
  },
  {
    title: "Terminator",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Est, tenetur.",
    date: "12/03/2023",
    views: "122",
  },
];

// add languages const

export const langArray = [
  { value: "tamil", label: "Tamil" },
  { value: "English", label: "English" },
  { value: "Hindi", label: "Hindi" },
];
export const LoginInFields = [
  {
    label: "Login",
    placeholder: "Login Id",
  },
  {
    label: "Email or Phone",
    placeholder: "Email or Phone",
  },
  {
    label: "Password",
    placeholder: "Password",
  },
];
export const SignUpFields = [
  {
    label: "Sign Up",
    placeholder: "Sign Up",
  },
  {
    label: "Email or Phone",
    placeholder: "Email or Phone",
  },
];
